import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  isExpanded: boolean;
  height: number;
  width: number;
  onMouseMove: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export default function ChatWrapper({
  children,
  isExpanded,
  height,
  width,
  onMouseMove,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  return (
    <div
      className="flex flex-col gap-1 min-w-fit"
      style={{
        height: isExpanded
          ? "min(calc(22rem + (80vh - 22rem - var(--boundary-offset-y) * 2) - 2.375rem), 100%)"
          : `min(calc(22rem + (80vh - 22rem - var(--boundary-offset-y) * 2) * ${height} / 100 - 2.375rem), 100%)`,
        width: `calc(22rem + (30vw - 22rem) * ${width} / 100)`,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
    >
      {children}
    </div>
  );
}
